import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { usePlansModal } from "../../shared/PlansModal";
import { useTrialBanner } from "./useTrialBanner";

export const TrialBanner = () => {
  const {
    trialEndDateMonthAndDayFormatted,
    expiringInTimer,
    trackTrialBannerClick,
  } = useTrialBanner();
  const plansModal = usePlansModal();
  const { isCircleV4 } = useCircleV4();

  const handleOnClick = () => {
    trackTrialBannerClick();
    void plansModal.show();
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="warning"
        icon="clock"
        iconColor="warning"
        title={t("trial_banner.upgrade_to_prevent", {
          formatted_date: trialEndDateMonthAndDayFormatted,
        })}
        description={
          expiringInTimer
            ? t("trial_banner.expiring_in", {
                expiring_in_timer: expiringInTimer,
              })
            : undefined
        }
        actionProps={{
          variant: "outline",
          children: t("trial_banner.cta"),
          onClick: handleOnClick,
        }}
      />
    );
  }

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-md">
          {t("trial_banner.upgrade_to_prevent", {
            formatted_date: trialEndDateMonthAndDayFormatted,
          })}
        </Typography.BodySm>
        {expiringInTimer && (
          <Typography.BodySm weight="font-normal" size="text-md">
            {t("trial_banner.expiring_in", {
              expiring_in_timer: expiringInTimer,
            })}
          </Typography.BodySm>
        )}

        <Button
          className="ml-1 text-md font-semibold"
          variant="circle"
          onClick={handleOnClick}
        >
          {t("trial_banner.cta")}
        </Button>
      </div>
    </div>
  );
};
